import * as Yup from "yup";

export const LoginSchema = (t) => Yup.object({
  username: Yup.string().min(3, t("login.username-invalid")).max(255, t("login.username-invalid")).required(t("login.username-required")),
  password: Yup.string().min(8, t("login.password-min")).required(t("login.password-required")),
});

export const ForgotPasswordSchema = (t) => Yup.object({
  username: Yup.string()
              .min(3, t("login.username-invalid"))
              .max(255, t("login.username-invalid"))
              .matches(
                /^[0-9a-zA-Z]+([0-9a-zA-Z]*[-._+])*[0-9a-zA-Z]+(@[0-9a-zA-Z]+([-.][0-9a-zA-Z]+)*([0-9a-zA-Z]*[.])[a-zA-Z]{2,6})?$/,
                t("login.username-invalid"))
              .required(t("login.username-required")),
});

export const AuthenticateOTPSchema = (t) => Yup.object({
  otp: Yup.string()
    .required(t("authentication.enter-otp"))
    .min(6, t("authentication.otp-limit"))
    .max(6, t("authentication.otp-limit")),
});

export const ResetPasswordSchema = (t) => Yup.object({
  newPassword: Yup.string()
    .required(t("authentication.new-password-required"))
    .min(8, t("authentication.password-too-short"))
    .matches(
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#\$%\^&\*])(?=.)/,
      t("authentication.password-invalid")
    ),
    confirmPassword: Yup.string()
    .required(t("authentication.renter-password"))
    .oneOf([Yup.ref("newPassword"), null], t("authentication.both-password-same")),
});
